module.exports = __webpack_public_path__ + "img/zoom.10f89777.png";